<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<fe-header style="z-index: 10000"></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
<section class="banner py-4">
    <div class="banner__content container d-flex flex-column">
        <h1 class="banner__content__title">
            {{ 'fe_landing_faqs_title_text' | translate }}
        </h1>
        <p class="banner__content__text">
            {{ 'fe_landing_faqs_after_title_text' | translate }}
        </p>
        <h2
            class="banner__content__subtitle mt-4"
            [ngClass]="{
                placeholder: !banner,
                'placeholder-wave': !banner,
                'mw-50': !banner
            }"
        >
            {{ banner?.title || 'Loading title...' }}
        </h2>
        <p
            class="banner__content__text"
            [ngClass]="{
                placeholder: !banner,
                'placeholder-wave': !banner,
                'py-3': !banner
            }"
            [innerHTML]="banner?.content || 'Loading content...'"
        ></p>
    </div>
</section>
<section class="faq mb-26 mb-sm-20">
    <ng-container *ngIf="faqs; else noFAQs">
        <div ngbAccordion class="faq__content container px-2 px-md-4 pt-2">
            <div
                *ngFor="let faq of faqs"
                class="accordion-item rounded-0"
                [collapsed]="ssr.isPlatformBrowser()"
                ngbAccordionItem
                #accItem="ngbAccordionItem"
            >
                <div class="py-2">
                    <div
                        ngbAccordionHeader
                        ngbAccordionToggle
                        class="faq__content__visible d-flex flex-row justify-content-between justify-content-lg-start align-items-center py-2"
                    >
                        <h2 class="faq__content__visible__question mb-0">
                            {{ faq.question }}
                        </h2>
                        <img
                            class="faq__content__visible__icon ms-1 ms-sm-3"
                            [src]="'images/chevron-alt-down.png' | cdn"
                            alt="more info button"
                            [ngClass]="{ 'rotate-icon': !accItem.collapsed }"
                        />
                    </div>
                    <div ngbAccordionCollapse class="faq__content__hidden">
                        <div
                            ngbAccordionBody
                            class="pb-1 px-0"
                            [innerHTML]="faq.answer"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #noFAQs>
        <div
            class="placeholder-wave container px-2 px-md-4 pt-2 d-flex flex-column"
        >
            <div class="placeholder my-2 py-3"></div>
            <div class="placeholder my-2 py-3"></div>
            <div class="placeholder my-2 py-3"></div>
            <div class="placeholder my-2 py-3"></div>
            <div class="placeholder my-2 py-3"></div>
            <div class="placeholder my-2 py-3"></div>
        </div>
    </ng-template>
</section>
<fe-footer></fe-footer>
